
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tutorials",
      function () {
        return require("private-next-pages/tutorials/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tutorials"])
      });
    }
  